import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { chain, UpdateContext } from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type UpdatePickUpWarehouseParameter = {
    pickUpWarehouse: WarehouseModel;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<UpdatePickUpWarehouseParameter, UpdateSessionApiParameter, Session>;

export const UpdatePickUpWarehouseInCache: HandlerType = props => {
    if (props?.parameter?.pickUpWarehouse?.properties?.isAutoChange === "true") {
        return;
    }
    const pickUpWarehouse = props?.parameter?.pickUpWarehouse?.id;
    if (pickUpWarehouse && pickUpWarehouse !== undefined && pickUpWarehouse !== "") {
        localStorage.setItem("selectedShipBranch", JSON.stringify(props.parameter.pickUpWarehouse));
    }
};

addToChainAfter(chain, UpdateContext, UpdatePickUpWarehouseInCache);
